export type CatalogSeoMeta = {
  title: string;
  description: string;
};

export type CatalogSeoMetaInput = {
  cityName?: string | null;
  categoryName?: string | null;
  productName?: string | null;
};

export const formatSeoCityLocation = (cityName?: string | null): string => {
  const normalizedCityName = cityName?.trim();

  return normalizedCityName
    ? `в городе ${normalizedCityName}`
    : 'в вашем городе';
};

export const buildCatalogSeoMeta = ({
  cityName,
  categoryName,
  productName,
}: CatalogSeoMetaInput): CatalogSeoMeta => {
  const cityLocation = formatSeoCityLocation(cityName);

  if (productName) {
    const deliveryCategory = categoryName || 'блинов и супов';

    return {
      title: `${productName} заказать ${cityLocation} | Доставка ${deliveryCategory} на дом от БлинБери`,
      description: `Закажи ${productName} на дом или в офис ${cityLocation}. Доставка ${deliveryCategory} от БлинБери.`,
    };
  }

  if (categoryName) {
    return {
      title: `${categoryName} ${cityLocation} | Заказать с доставкой в БлинБери`,
      description: `Доставка ${categoryName} на дом или в офис ${cityLocation}. Сделай заказ на сайте БлинБери.`,
    };
  }

  return {
    title: `Доставка блинов и супов ${cityLocation} | Заказать блины и супы от БлинБери`,
    description: `Заказать блины и супы ${cityLocation} на дом или в офис. Акции и программа лояльности БлинБери.`,
  };
};
